import { useSyncExternalStore } from 'react';

import {
   getFlagUsageSnapshot,
   subscribeToFlagUsage,
} from '#helper/launchdarkly/feature-flag-usage-store';

const EMPTY_SNAPSHOT = Object.freeze([]);

const getServerSnapshot = () => EMPTY_SNAPSHOT;

// Returns flags being read by mounted components on the current page, e.g.
// [{ key: 'plp-category-featured-image', value: true }].
export const useActiveFeatureFlags = () =>
   useSyncExternalStore(subscribeToFlagUsage, getFlagUsageSnapshot, getServerSnapshot);
